import { FaCheck, FaTimes } from 'react-icons/fa';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  background-color: ${ColorPalette.HEX.Lotion};

  @media ${({ theme }) => theme.device.desktop} {
    background: ${ColorPalette.Transparent};
    max-width: 1300px;
  }
`;

export const ReportFiltersContainer: any = styled.div`
  padding: 20px 16px;
  display: flex;
  min-height: 420px;
  flex-direction: column;
  justify-content: space-between;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
    min-height: 0;
  }
`;

export const Divider = styled.div`
  height: 1px;
  border-bottom: solid 1px ${({ theme }) => theme.group.division};
`;

export const Table: any = styled.div`
  margin-bottom: 24px;
  border: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
  background-color: rgba(${ColorPalette.RGB.White}, 1);
  border-radius: 12px;
  overflow: hidden;
  align-items: stretch;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${ColorPalette.HEX.PhilippineSilver};
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    background: ${ColorPalette.HEX.AntiFlashWhite2};
  }
`;

Table.Container = styled.div`
  flex-wrap: nowrap;
  align-items: flex-start;
  overflow: auto;
  scroll-snap-type: both mandatory;
  min-width: 100%;
  max-height: calc(80vh - 195px);
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${ColorPalette.HEX.PhilippineSilver};
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    background: ${ColorPalette.HEX.AntiFlashWhite2};
  }
`;

Table.Item = styled.td`
  align-items: center;
  flex-direction: row;
  scroll-snap-align: start;
  padding-left: 18px;
  padding-right: 18px;
  height: 50px;
  min-height: 38px;
  max-height: 50px;
  border-left: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
  border-bottom: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
  background: ${ColorPalette.HEX.White};
  color: ${ColorPalette.HEX.DimGray2};
  line-height: 1.2em;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;

  &.title {
    position: sticky;
    top: 0;
    color: ${ColorPalette.HEX.PineTree};
    border-top: none;
    text-align: center;
    font-size: 14px;
  }

  &.head {
    color: ${ColorPalette.HEX.PineTree};
    flex-direction: column;
    align-items: flex-start;
    font-size: 14px;
  }

  &.footer {
    position: sticky;
    bottom: 0;
    font-size: 14px;
    border-top: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
    margin-top: -1px;
    flex-direction: column;
    height: auto;
    min-height: 56px;
    max-height: 56px;
  }
`;

Table.Div = styled.div`
  display: flex;
  padding: 4px 0;
`;

Table.Column = styled.div`
  scroll-snap-align: start;
  flex: 0 0 190px;

  &.title {
    flex: 1;
    min-width: 286px;
    background-color: ${ColorPalette.HEX.White};
    z-index: 1;
  }
  &:first-child ${Table.Item} {
    border-left: none;
  }
`;

export const YesIcon = styled(FaCheck)`
  color: ${ColorPalette.HEX.GreenPantone} !important;
  width: 14px;
  height: 14px;
  vertical-align: middle;
`;

export const NoIcon = styled(FaTimes)`
  color: ${ColorPalette.HEX.RedRYB} !important;
  width: 14px;
  height: 14px;
  vertical-align: middle;
`;

export const Icon = styled.span`
  display: inline;
`;

export const Text = styled.span`
  display: inline;
  margin-left: 5px;
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const Price = styled.span`
  margin-left: 5px;
  font-size: 14px;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const ButtonContainer = styled.div`
  width: 165px;
  align-self: flex-end;
`;

export const Title = styled.h3`
  font-weight: 600;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.group.section.title};
`;
